module.exports = __webpack_public_path__ + "static/img/bg-es.731140c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/godfather/bg-es.jpg
// module id = lTT7
// module chunks = 1